<template>
  <keep-alive include="skuInfoList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "SkuInfo",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
